module.exports = __webpack_public_path__ + "img/avvo.583fdcc1.png";